module.exports = __webpack_public_path__ + "static/img/main.219659e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/KOF14/intro/main.jpg
// module id = C2cT
// module chunks = 0